"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textLinkStyles = void 0;

var _styledComponents = require("styled-components");

var _theme = _interopRequireDefault(require("../theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-size: 1.4rem;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var textLinkStyles = (0, _styledComponents.css)(["text-decoration:none;font-weight:600;&:hover{text-decoration:underline;}color:", ";"], function (_ref) {
  var color = _ref.color;
  return color === 'white' ? 'white' : _theme["default"].indigo60;
});
exports.textLinkStyles = textLinkStyles;
var anchorStyles = (0, _styledComponents.css)(["color:", ";font-family:", ";font-size:1.6rem;cursor:pointer;text-decoration:none;:hover{color:", ";text-decoration:underline;}", ""], _theme["default"].indigo80, _theme["default"].buenosAires, _theme["default"].indigo60, _theme["default"].mediaLargePlus(_templateObject()));
var _default = anchorStyles;
exports["default"] = _default;